class BankAccounts {
	constructor(bankAccount) {
		this.bankAccount = bankAccount;
	}
	getBankId() {
		return this.bankAccount.bankId;
	}
	getBankAccountNumber() {
		return this.bankAccount.accountNumber;
	}
	getBankAccountName() {
		return this.bankAccount.name;
	}
	getBankName() {
		return this.bankAccount.bank.name;
	}
	getBankPersonName() {
		return this.bankAccount.additionalInformation.personName;
	}
	getBankpersonDocumentNumber() {
		return this.bankAccount.additionalInformation.personDocumentNumber;
	}
	getBankdocumentEmail() {
		return this.bankAccount.additionalInformation.documentEmail;
	}
}

export default BankAccounts;



// WEBPACK FOOTER //
// ./src/class/BankAccount.js